import { j as s } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as t } from "react";
import { I as o } from "../../../../IconBase-CxZyIWw2.js";
const i = t((e, r) => /* @__PURE__ */ s.jsx(
  o,
  {
    ref: r,
    ...e,
    image: (a) => /* @__PURE__ */ s.jsxs(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...a,
        children: [
          /* @__PURE__ */ s.jsx(
            "mask",
            {
              id: "mask0_2974_3552",
              width: 17,
              height: 16,
              x: 0,
              y: 0,
              maskUnits: "userSpaceOnUse",
              style: {
                maskType: "alpha"
              },
              children: /* @__PURE__ */ s.jsx(
                "path",
                {
                  fill: "currentColor",
                  d: "M13.51 0a2.5 2.5 0 0 0 0 5 2.5 2.5 0 0 0 0-5m0 3.5c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1M7.25 3.25c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H.75c-.41 0-.75.34-.75.75 0 .03.02.06.02.1v6.18c0 .03-.02.05-.02.09s.02.06.02.1v6.27c0 .41.34.75.75.75s.75-.34.75-.75V9.62h5.73c.41 0 .75-.34.75-.75s-.34-.75-.75-.75H1.52V3.25z"
                }
              )
            }
          ),
          /* @__PURE__ */ s.jsx("g", { mask: "url(#mask0_2974_3552)", children: /* @__PURE__ */ s.jsx("path", { fill: "currentColor", d: "M0 0h16v16H0z" }) })
        ]
      }
    )
  }
));
i.displayName = "AgencyTemperatureIcon";
export {
  i as AgencyTemperatureIcon,
  i as default
};
//# sourceMappingURL=index.js.map
